oyc.MediaPlayer = {
  selectors: {
    container: '.video-embed',
    items: 'video, audio'
  },
  initOptions: {
    toggleCaptionsButtonWhenOnlyOne: true,
    iconSprite: '/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Img/symbol-defs.svg',
    features: ['current', 'progress', 'duration', 'playpause', 'tracks', 'a11y', 'volume', 'fullscreen']
  },
  container: null,
  items: null,
  libsLoaded: false,
  init: function () {
    this.container = $(this.selectors.container);
    if (0 < this.container.length) {
      this.items = this.container.find(this.selectors.items);
      this.loadLibsAndInit(this.items);
      this.addEvents();
    }
  },
  loadLibsAndInit: function (items) {
    this.items = items;

    oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Css/Async/mediaelementplayer.css')
    oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/mediaelement-and-player.min.js')
      .then(function () {
        return Promise.all([
          oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/a11y.min.js'),
          oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/a11y-de.js'),
          oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/a11y-i18n.js')
        ]);
      })
      .then(function () {
        oyc.MediaPlayer.libsLoaded = true;
        mejs.i18n.language('de');
        oyc.MediaPlayer.items.mediaelementplayer(oyc.MediaPlayer.initOptions);
        $('.mejs__container').removeAttr('tabindex');
      });
  },
  initContainer: function (el) {
    let items = $(el);
    if (this.libsLoaded) {
      items.mediaelementplayer(this.initOptions);
      $('.mejs__container').removeAttr('tabindex');
    } else {
      this.loadLibsAndInit(items);
    }
    this.addEvents(items);
  },
  addEvents: function (el) {
    let items = this.items;
    if (typeof el !== 'undefined') {
      if (!('length' in el)) {
        items = $(el);
      } else {
        items = el
      }
    }
    items.bind('playing', function (e) {
      let container = $(e.currentTarget).closest(this.selectors.container);
      container.find('.image-figure').fadeOut();
      container.find('.mejs__playpause-button button').focus();
    }.bind(this));
    items.bind('ended', function (e) {
      $(e.currentTarget).find('.image-figure').fadeIn();
    }.bind(this));
  }
}
